<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <b-card>
      <template slot="header">
        <h3 class="inline">{{titulo}}</h3>
        <b-button class="float-right" variant="success" @click="confirmarEnvio">Confirmar Envio</b-button>
        <b-button class="float-right m-r-3" variant="danger" @click="goBack">Cancelar Envio</b-button>
      </template>
      <b-row>
        <b-col xs="12" lg="12">
          <b-card no-body class="no-margin-bottom">
            <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex[0]">
              <b-tab active title-link-class="tab-link-color">
                <template slot="title">
                  <i class="fa fa-paper-plane tab-icon"></i>
                  {{tabs[0]}}
                </template>
                <div class="text-center">
                  <b-row>
                    <b-col xl="6" sm="12">
                      <b-input-group prepend="Titulo" class="mb-3">
                        <b-form-input v-model="tituloPush" />
                      </b-input-group>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <b-input-group prepend="Descrição" class="mb-3">
                        <b-form-input v-model="descricaoPush" />
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <h4>Selecione um filtro para realizar o envio dos pushs</h4>
                  <h6>Pushs disponíveis: {{ qtdPush }}</h6>
                  <small>Selecionado: {{ pushTabIndex == 0 ? 'Todos os clientes' : pushTabIndex == 1 ? 'Por Interesse' : 'Por Seleção' }}</small>
                </div>
                <b-col cols="12">
                  <b-tabs content-class="mt-3" v-model="pushTabIndex">
                    <b-tab title="Todos os clientes" active>
                      <p class="texto-all-clientes">
                        Enviará para todos os clientes cadastrados na plataforma mobile,
                        que totaliza
                        <strong>{{qtdClientesCadastrados}}</strong>
                        {{qtdClientesCadastrados == 1 ? 'cliente' : 'clientes'}}.
                      </p>
                    </b-tab>
                    <b-tab title="Por interesse">
                      <p>Enviará de acordo com os interesses selecionados.</p>
                      <b-row>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-form-group>
                            <b-input-group size="sm" prepend="Buscar">
                              <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Digite para pesquisar"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                          ></b-pagination>
                        </b-col>
                      </b-row>
                      <b-table
                        :items="interesses"
                        :fields="interessesFields"
                        striped
                        hover
                        responsive="sm"
                        bordered
                        @row-clicked="selecionaInteresse"
                        @head-clicked="selectInteressesHead"
                        :filter="filter"
                        :filterIncludedFields="filterOn"
                        @filtered="onFiltered"
                        :current-page="currentPage"
                        :per-page="perPage"
                      >
                        <template slot="HEAD_selecionado">
                          <label class="form-checkbox">
                            <input
                              type="checkbox"
                              v-model="selecionarTodosOsInteresses"
                              @click="selectInteresses"
                            />
                            <i class="form-icon"></i>
                          </label>
                        </template>
                        <template slot="HEAD_descricao">Descrição</template>
                        <template slot="selecionado" slot-scope="data">
                          <label class="form-checkbox">
                            <input
                              type="checkbox"
                              :value="data.item.id"
                              v-model="interessesSelecionados"
                            />
                            <i class="form-icon"></i>
                          </label>
                        </template>
                      </b-table>
                    </b-tab>
                    <b-tab title="Por seleção">
                      <p>Seleção unitária de clientes.</p>
                      <b-row>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-form-group>
                            <b-input-group size="sm" prepend="Buscar">
                              <b-form-input
                                v-model="filterSelecao"
                                type="search"
                                id="filterInputSelecao"
                                placeholder="Digite para pesquisar"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button :disabled="!filter" @click="filterSelecao = ''">Limpar</b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-pagination
                            v-model="currentPageSelecao"
                            :total-rows="totalRowsSelecao"
                            :per-page="perPageSelecao"
                            align="fill"
                            size="sm"
                          ></b-pagination>
                        </b-col>
                      </b-row>
                      <b-table
                        :items="clientes"
                        :fields="clientesFields"
                        striped
                        hover
                        responsive="sm"
                        bordered
                        @row-clicked="selecionaCliente"
                        @head-clicked="selectClientesHead"
                        :filter="filterSelecao"
                        :filterIncludedFields="filterOnSelecao"
                        @filtered="onFilteredSelecao"
                        :current-page="currentPageSelecao"
                        :per-page="perPageSelecao"
                      >
                        <template slot="HEAD_selecionado">
                          <label class="form-checkbox">
                            <input
                              type="checkbox"
                              v-model="selecionarTodosOsClientes"
                              @click="selectClientes"
                            />
                            <i class="form-icon"></i>
                          </label>
                        </template>
                        <template slot="HEAD_nome">Nome completo</template>
                        <template slot="selecionado" slot-scope="data">
                          <label class="form-checkbox">
                            <input
                              type="checkbox"
                              :value="data.item.id"
                              v-model="clientesSelecionados"
                            />
                            <i class="form-icon"></i>
                          </label>
                        </template>
                        <template v-slot:cell(nome)="data">{{ data.item.nome }} {{ data.item.sobrenome }}</template>
                      </b-table>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-tab>
              <b-tab disabled>
                <template slot="title">
                  <i class="fa fa-envelope tab-icon"></i>
                  {{tabs[1]}}
                </template>
                2
              </b-tab>
              <b-tab disabled>
                <template slot="title">
                  <i class="fa fa-phone tab-icon"></i>
                  {{tabs[2]}}
                </template>
                3
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import { Switch as cSwitch } from "@coreui/vue";
import * as config from "@/config.json";
import axios from "axios";

export default {
  name: "configurar-distribuicao",
  components: {
    Loading,
    cSwitch
  },
  data: function() {
    return {
      isLoading: false,
      id: null,
      titulo: null,
      descricao: null,
      havePush: null,
      haveEmail: null,
      tabIndex: [0],
      tabs: ["Push", "E-mail", "SMS"],
      pushTabIndex: 0,
      qtdClientesCadastrados: 0,
      interesses: [],
      interessesFields: ["selecionado", "descricao"],
      interessesSelecionados: [],
      selecionarTodosOsInteresses: false,
      clientes: [],
      clientesFields: ["selecionado", "nome"],
      clientesSelecionados: [],
      selecionarTodosOsClientes: false,
      pushPreparado: null,
      tituloPush: null,
      descricaoPush: null,
      isJornalzinho: null,
      qtdPush: null,
      countEnvio: null,
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 1,
      filterSelecao: null,
      currentPageSelecao: 1,
      perPageSelecao: 5,
      filterOnSelecao: [],
      totalRowsSelecao: 1
    };
  },
  methods: {
    paginacao() {
      // Set the initial number of items
      this.totalRows = this.interesses.length;
    },
    paginacaoSelecao() {
      // Set the initial number of items
      this.totalRowsSelecao = this.clientes.length;
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredSelecao(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsSelecao = filteredItems.length;
      this.currentPageSelecao = 1;
    },
    selectInteressesHead() {
      this.selectInteresses();
      this.selecionarTodosOsInteresses = !this.selecionarTodosOsInteresses;
    },
    selectInteresses() {
      this.interessesSelecionados = [];
      if (!this.selecionarTodosOsInteresses) {
        for (let i in this.interesses) {
          this.interessesSelecionados.push(this.interesses[i].id);
        }
      }
    },
    selecionaInteresse(record, index) {
      var arr = [];
      var lock = false;
      for (let i = 0; i < this.interessesSelecionados.length; i++) {
        const e = this.interessesSelecionados[i];
        if (e == record.id) {
          lock = true;
        } else {
          arr.push(e);
        }
      }
      if (!lock) {
        arr.push(record.id);
      }
      this.interessesSelecionados = arr;
    },
    selectClientesHead() {
      this.selectClientes();
      this.selecionarTodosOsClientes = !this.selecionarTodosOsClientes;
    },
    selectClientes() {
      this.clientesSelecionados = [];
      if (!this.selecionarTodosOsClientes) {
        for (let i in this.clientes) {
          this.clientesSelecionados.push(this.clientes[i].id);
        }
      }
    },
    selecionaCliente(record, index) {
      var arr = [];
      var lock = false;
      for (let i = 0; i < this.clientesSelecionados.length; i++) {
        const e = this.clientesSelecionados[i];
        if (e == record.id) {
          lock = true;
        } else {
          arr.push(e);
        }
      }
      if (!lock) {
        arr.push(record.id);
      }
      this.clientesSelecionados = arr;
    },
    prepararPush() {
      var push = {};
      push.tipo = this.pushTabIndex;
      push.tipoid = 2;
      push.id_direcionado = this.id;
      push.titulo = this.tituloPush;
      push.descricao = this.descricaoPush;
      
      if (this.pushTabIndex == 1) {
        if (this.interessesSelecionados.length > 0) {
          push.dados = this.interessesSelecionados;
        } else {
          return false;
        }
      } else if (this.pushTabIndex == 2) {
        if (this.clientesSelecionados.length > 0) {
          push.dados = this.clientesSelecionados;
        } else {
          return false;
        }
      }
      this.pushPreparado = push;
      return true;
    },

    confirmarEnvio() {
      if (this.tituloPush == null || this.descricaoPush == null) {
        const options = { title: "Aviso", size: "sm" };
        this.$dialogs
          .alert("Preencha os campos corretamente.", options)
          .then(res2 => {});
      } else {
        if (this.prepararPush == null) {
          const options = { title: "Aviso", size: "sm" };
          this.$dialogs
            .alert("Preencha corretamente o filtro.", options)
            .then(res2 => {});
        } else {
          this.enviar();
        }
      }
    },
    enviar() {
      axios
        .put(
          `${config.default.servidor}/gerencial/inserir-envio-push`,
          {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            push: this.pushPreparado
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Campanha reenviada com sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
            this.$router.go(-1);
          }
        })
        .catch(error => {
          this.countEnvio = error.response.data.count;
          if (error.response.status == 403) {
            const options = { title: "Aviso", size: "sm" };
            this.$dialogs
              .alert(
                `Você não possui saldo de push's suficiente para completar esta operação.\nSaldo atual: ${this.qtdPush}\nSelecionados para envio: ${this.countEnvio}`,
                options
              )
              .then(res2 => {});
          }
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  async beforeMount() {
    this.id = localStorage.getItem("id");
    localStorage.removeItem("id");
    this.isPromocao = localStorage.getItem("isPromocao").toString();
    localStorage.removeItem("isPromocao");
    this.isLoading = true;
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-parametros-configurar-distribuicao/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        this.qtdClientesCadastrados = response.data.todosOsClientes;
        this.interesses = response.data.interesses;
        this.clientes = response.data.clientes;
      });
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-pushs-disponiveis/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.status == 200) {
          this.qtdPush = response.data.pushsDisponiveis;
        }
      });
    this.isLoading = false;
    this.paginacao();
    this.paginacaoSelecao();
  }
};
</script>
